/* UGC carousel arrows: homepage collage grid (collage_grid_4tEDzU) */
(function () {
  var SELECTOR = '[id$="__collage_grid_4tEDzU"]';
  var PREV_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var NEXT_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';

  function makeButton(dir, label, icon) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ugc-arrow ugc-arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = icon;
    return b;
  }

  function init() {
    var section = document.querySelector(SELECTOR);
    if (!section) return;
    var track = section.querySelector('.collage.with-grid');
    if (!track || track.parentElement.classList.contains('ugc-carousel')) return;

    var wrap = document.createElement('div');
    wrap.className = 'ugc-carousel';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    var prev = makeButton('prev', 'Previous images', PREV_ICON);
    var next = makeButton('next', 'Next images', NEXT_ICON);
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() {
      var item = track.querySelector('.collage__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var size = item.getBoundingClientRect().width + gap;
      var count = Math.max(1, Math.floor((track.clientWidth + gap) / size));
      return size * count;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      wrap.classList.toggle('is-static', max <= 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
